import { createAction } from '@ngrx/store';

export const resetAppState = createAction('[App] Reset State');